import { isInFiltersPolishExperiment } from '@client/redux/experiments/selectors/filters-polish';
import { selectAtom } from 'jotai/utils';
import { reduxAtom } from './redux-atoms';

export const isInFiltersPolishExperimentAtom = selectAtom(
	reduxAtom,
	isInFiltersPolishExperiment,
);

export const categoryIdAtom = selectAtom(
	reduxAtom,
	(state) => state.category.id,
);
export const categoryCodeAtom = selectAtom(
	reduxAtom,
	(state) => state.category.code,
);

export const sidebarCategoriesAtom = selectAtom(
	reduxAtom,
	(state) => state.search.filterPills.sidebar.categories,
);

// Redux selectors for search count dependencies
export const cityAtom = selectAtom(reduxAtom, (state) => state.location.city);
export const stateCodeAtom = selectAtom(
	reduxAtom,
	(state) => state.location.stateCode,
);
export const marketCodeAtom = selectAtom(
	reduxAtom,
	(state) => state.search.marketCode,
);
export const anonymousIdAtom = selectAtom(
	reduxAtom,
	(state) => state.settings?.anonymousId || '',
);
export const userIdAtom = selectAtom(
	reduxAtom,
	(state) => state.membership?.member?.id ?? null,
);
export const searchTotalAtom = selectAtom(
	reduxAtom,
	(state) => state.search.total,
);
export const isMobileAtom = selectAtom(
	reduxAtom,
	(state) => state.viewport.isMobile,
);
export const vendorStorefrontIdAtom = selectAtom(
	reduxAtom,
	(state) => state.vendor.vendor?.id ?? null,
);
